"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNotificationError = _interopRequireDefault(require("../../images/icon-notification-error.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var IconNotificationAlert = function IconNotificationAlert() {
  return /*#__PURE__*/_react.default.createElement("img", {
    alt: "Notification alert",
    className: "icon-notification-alert",
    src: _iconNotificationError.default
  });
};
var _default = IconNotificationAlert;
exports.default = _default;